export enum CLASS_AVATAR_SIZES {
    LARGE = 'large',
    SMALL = 'small',
}
